import { c as _c } from "react/compiler-runtime";
import Backspace from "@mui/icons-material/Backspace";
import FilterList from "@mui/icons-material/FilterList";
import Search from "@mui/icons-material/Search";
import SwapVert from "@mui/icons-material/SwapVert";
import { Box, IconButton, InputAdornment, Menu, MenuItem, Stack, Tooltip } from "@mui/material";
import React, { useState } from "react";
import { useI18nContext } from "#/shared/hooks";
import { DebouncedInput } from "#/shared/ui/molecules/DebouncedInput";
import { useProjectBrowserContext } from "./ProjectBrowserContext";
import { ProjectBrowserFilters } from "./ProjectBrowserFilters";
type ProjectBrowserHeaderProps = {
  searchValue: string;
  onSearchChange: (value: string) => void;
  searchInputRef?: React.RefObject<HTMLInputElement | null>;
};
type SortOption = {
  value: "title" | "difficulty" | "date" | "category";
  label: string;
  ascLabel: string;
  descLabel: string;
};
export const ProjectBrowserHeader: React.FC<ProjectBrowserHeaderProps> = t0 => {
  const $ = _c(130);
  const {
    searchValue,
    onSearchChange,
    searchInputRef
  } = t0;
  const {
    LL
  } = useI18nContext();
  const {
    sortBy,
    sortOrder,
    setSort,
    selectedDifficulties,
    showOnlyNew
  } = useProjectBrowserContext();
  const [sortMenuAnchor, setSortMenuAnchor] = useState(null);
  const [filterMenuAnchor, setFilterMenuAnchor] = useState(null);
  const [filterPopoverOpen, setFilterPopoverOpen] = useState(false);
  let t1;
  if ($[0] !== LL) {
    t1 = LL.SORT_TITLE();
    $[0] = LL;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== LL) {
    t2 = LL.SORT_TITLE_ASC();
    $[2] = LL;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== LL) {
    t3 = LL.SORT_TITLE_DESC();
    $[4] = LL;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = {
      value: "title",
      label: t1,
      ascLabel: t2,
      descLabel: t3
    };
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== LL) {
    t5 = LL.SORT_DIFFICULTY();
    $[10] = LL;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== LL) {
    t6 = LL.SORT_DIFFICULTY_ASC();
    $[12] = LL;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== LL) {
    t7 = LL.SORT_DIFFICULTY_DESC();
    $[14] = LL;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t5 || $[17] !== t6 || $[18] !== t7) {
    t8 = {
      value: "difficulty",
      label: t5,
      ascLabel: t6,
      descLabel: t7
    };
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== LL) {
    t9 = LL.SORT_DATE();
    $[20] = LL;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== LL) {
    t10 = LL.SORT_DATE_ASC();
    $[22] = LL;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== LL) {
    t11 = LL.SORT_DATE_DESC();
    $[24] = LL;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t10 || $[27] !== t11 || $[28] !== t9) {
    t12 = {
      value: "date",
      label: t9,
      ascLabel: t10,
      descLabel: t11
    };
    $[26] = t10;
    $[27] = t11;
    $[28] = t9;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== LL) {
    t13 = LL.SORT_CATEGORY();
    $[30] = LL;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== LL) {
    t14 = LL.SORT_CATEGORY_ASC();
    $[32] = LL;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] !== LL) {
    t15 = LL.SORT_CATEGORY_DESC();
    $[34] = LL;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] !== t13 || $[37] !== t14 || $[38] !== t15) {
    t16 = {
      value: "category",
      label: t13,
      ascLabel: t14,
      descLabel: t15
    };
    $[36] = t13;
    $[37] = t14;
    $[38] = t15;
    $[39] = t16;
  } else {
    t16 = $[39];
  }
  let t17;
  if ($[40] !== t12 || $[41] !== t16 || $[42] !== t4 || $[43] !== t8) {
    t17 = [t4, t8, t12, t16];
    $[40] = t12;
    $[41] = t16;
    $[42] = t4;
    $[43] = t8;
    $[44] = t17;
  } else {
    t17 = $[44];
  }
  const SORT_OPTIONS = t17;
  const handlePropagation = _temp;
  let t18;
  if ($[45] !== onSearchChange) {
    t18 = value => {
      onSearchChange(value.trim());
    };
    $[45] = onSearchChange;
    $[46] = t18;
  } else {
    t18 = $[46];
  }
  const handleChange = t18;
  let t19;
  if ($[47] !== onSearchChange) {
    t19 = ev_0 => {
      handlePropagation(ev_0);
      onSearchChange("");
    };
    $[47] = onSearchChange;
    $[48] = t19;
  } else {
    t19 = $[48];
  }
  const handleClear = t19;
  let t20;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = ev_1 => {
      handlePropagation(ev_1);
      setSortMenuAnchor(ev_1.currentTarget);
    };
    $[49] = t20;
  } else {
    t20 = $[49];
  }
  const handleSortMenuOpen = t20;
  let t21;
  if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = () => {
      setSortMenuAnchor(null);
    };
    $[50] = t21;
  } else {
    t21 = $[50];
  }
  const handleSortMenuClose = t21;
  let t22;
  if ($[51] !== setSort) {
    t22 = (option, order) => {
      const orderCapitalized = order.charAt(0).toUpperCase() + order.slice(1);
      const sortValue = `${option.value}${orderCapitalized}`;
      setSort(sortValue);
      handleSortMenuClose();
    };
    $[51] = setSort;
    $[52] = t22;
  } else {
    t22 = $[52];
  }
  const handleSortSelect = t22;
  let t23;
  if ($[53] !== filterPopoverOpen) {
    t23 = event => {
      handlePropagation(event);
      if (filterPopoverOpen) {
        setFilterMenuAnchor(null);
        setFilterPopoverOpen(false);
        return;
      }
      setFilterMenuAnchor(event.currentTarget);
      setFilterPopoverOpen(true);
    };
    $[53] = filterPopoverOpen;
    $[54] = t23;
  } else {
    t23 = $[54];
  }
  const handleFilterClick = t23;
  let t24;
  if ($[55] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = () => {
      setFilterMenuAnchor(null);
      setFilterPopoverOpen(false);
    };
    $[55] = t24;
  } else {
    t24 = $[55];
  }
  const handleFilterClose = t24;
  let t25;
  if ($[56] !== SORT_OPTIONS || $[57] !== sortBy) {
    t25 = SORT_OPTIONS.find(opt => opt.value === sortBy);
    $[56] = SORT_OPTIONS;
    $[57] = sortBy;
    $[58] = t25;
  } else {
    t25 = $[58];
  }
  const currentSortOption = t25;
  const sortLabel = sortOrder === "asc" ? currentSortOption?.ascLabel : currentSortOption?.descLabel;
  const hasActiveFilters = selectedDifficulties.length > 0 || showOnlyNew;
  let t26;
  if ($[59] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = {
      p: 2,
      borderBottom: 1,
      borderColor: "divider"
    };
    $[59] = t26;
  } else {
    t26 = $[59];
  }
  let t27;
  if ($[60] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = {
      flex: 1
    };
    $[60] = t27;
  } else {
    t27 = $[60];
  }
  let t28;
  if ($[61] !== LL) {
    t28 = LL.SEARCH_PROJECTS();
    $[61] = LL;
    $[62] = t28;
  } else {
    t28 = $[62];
  }
  let t29;
  if ($[63] !== LL) {
    t29 = LL.SEARCH_PROJECTS();
    $[63] = LL;
    $[64] = t29;
  } else {
    t29 = $[64];
  }
  let t30;
  if ($[65] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = {
      pointerEvents: "auto"
    };
    $[65] = t30;
  } else {
    t30 = $[65];
  }
  let t31;
  if ($[66] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = {
      startAdornment: <InputAdornment position="start"><Search sx={{
          color: "text.secondary",
          fontSize: 20
        }} /></InputAdornment>
    };
    $[66] = t31;
  } else {
    t31 = $[66];
  }
  let t32;
  if ($[67] !== handleChange || $[68] !== searchInputRef || $[69] !== searchValue || $[70] !== t28 || $[71] !== t29) {
    t32 = <Box sx={t27}><DebouncedInput inputRef={searchInputRef} label={t28} title={t29} name="search-project-browser" size="small" fullWidth={true} value={searchValue} onChange={handleChange} onClick={handlePropagation} onKeyDown={handlePropagation} sx={t30} timeout={200} InputProps={t31} /></Box>;
    $[67] = handleChange;
    $[68] = searchInputRef;
    $[69] = searchValue;
    $[70] = t28;
    $[71] = t29;
    $[72] = t32;
  } else {
    t32 = $[72];
  }
  let t33;
  if ($[73] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = {
      pointerEvents: "auto"
    };
    $[73] = t33;
  } else {
    t33 = $[73];
  }
  let t34;
  if ($[74] === Symbol.for("react.memo_cache_sentinel")) {
    t34 = <Backspace fontSize="small" />;
    $[74] = t34;
  } else {
    t34 = $[74];
  }
  let t35;
  if ($[75] !== handleClear) {
    t35 = <IconButton title="Clear search input" size="small" onClick={handleClear} sx={t33} aria-label="Clear search">{t34}</IconButton>;
    $[75] = handleClear;
    $[76] = t35;
  } else {
    t35 = $[76];
  }
  let t36;
  if ($[77] !== t32 || $[78] !== t35) {
    t36 = <Stack direction="row" spacing={1} alignItems="center" onClick={handlePropagation}>{t32}{t35}</Stack>;
    $[77] = t32;
    $[78] = t35;
    $[79] = t36;
  } else {
    t36 = $[79];
  }
  let t37;
  if ($[80] !== LL || $[81] !== sortLabel) {
    t37 = sortLabel || LL.SORT_BY();
    $[80] = LL;
    $[81] = sortLabel;
    $[82] = t37;
  } else {
    t37 = $[82];
  }
  let t38;
  if ($[83] !== LL) {
    t38 = LL.SORT_BY();
    $[83] = LL;
    $[84] = t38;
  } else {
    t38 = $[84];
  }
  const t39 = Boolean(sortMenuAnchor);
  let t40;
  let t41;
  if ($[85] === Symbol.for("react.memo_cache_sentinel")) {
    t40 = {
      border: 1,
      borderColor: "divider",
      borderRadius: 1
    };
    t41 = <SwapVert fontSize="small" />;
    $[85] = t40;
    $[86] = t41;
  } else {
    t40 = $[85];
    t41 = $[86];
  }
  let t42;
  if ($[87] !== t38 || $[88] !== t39) {
    t42 = <IconButton onClick={handleSortMenuOpen} size="small" aria-label={t38} aria-haspopup="true" aria-expanded={t39} sx={t40}>{t41}</IconButton>;
    $[87] = t38;
    $[88] = t39;
    $[89] = t42;
  } else {
    t42 = $[89];
  }
  let t43;
  if ($[90] !== t37 || $[91] !== t42) {
    t43 = <Tooltip title={t37} arrow={true}>{t42}</Tooltip>;
    $[90] = t37;
    $[91] = t42;
    $[92] = t43;
  } else {
    t43 = $[92];
  }
  const t44 = hasActiveFilters ? "primary.main" : "divider";
  const t45 = hasActiveFilters ? "primary.main" : "transparent";
  const t46 = hasActiveFilters ? "primary.contrastText" : "inherit";
  const t47 = hasActiveFilters ? "primary.dark" : "action.hover";
  let t48;
  if ($[93] !== t47) {
    t48 = {
      backgroundColor: t47
    };
    $[93] = t47;
    $[94] = t48;
  } else {
    t48 = $[94];
  }
  let t49;
  if ($[95] !== t44 || $[96] !== t45 || $[97] !== t46 || $[98] !== t48) {
    t49 = {
      border: 1,
      borderColor: t44,
      borderRadius: 1,
      backgroundColor: t45,
      color: t46,
      "&:hover": t48
    };
    $[95] = t44;
    $[96] = t45;
    $[97] = t46;
    $[98] = t48;
    $[99] = t49;
  } else {
    t49 = $[99];
  }
  let t50;
  if ($[100] === Symbol.for("react.memo_cache_sentinel")) {
    t50 = <FilterList fontSize="small" />;
    $[100] = t50;
  } else {
    t50 = $[100];
  }
  let t51;
  if ($[101] !== filterPopoverOpen || $[102] !== handleFilterClick || $[103] !== t49) {
    t51 = <Tooltip title="Advanced filters" arrow={true}><IconButton onClick={handleFilterClick} size="small" aria-label="Advanced filters" aria-haspopup="true" aria-expanded={filterPopoverOpen} sx={t49}>{t50}</IconButton></Tooltip>;
    $[101] = filterPopoverOpen;
    $[102] = handleFilterClick;
    $[103] = t49;
    $[104] = t51;
  } else {
    t51 = $[104];
  }
  let t52;
  if ($[105] !== t43 || $[106] !== t51) {
    t52 = <Stack direction="row" spacing={1} alignItems="center" justifyContent="flex-start">{t43}{t51}</Stack>;
    $[105] = t43;
    $[106] = t51;
    $[107] = t52;
  } else {
    t52 = $[107];
  }
  let t53;
  if ($[108] !== t36 || $[109] !== t52) {
    t53 = <Stack spacing={1.5}>{t36}{t52}</Stack>;
    $[108] = t36;
    $[109] = t52;
    $[110] = t53;
  } else {
    t53 = $[110];
  }
  const t54 = Boolean(sortMenuAnchor);
  let t55;
  if ($[111] === Symbol.for("react.memo_cache_sentinel")) {
    t55 = {
      paper: {
        onClick: handlePropagation
      }
    };
    $[111] = t55;
  } else {
    t55 = $[111];
  }
  let t56;
  let t57;
  if ($[112] !== SORT_OPTIONS || $[113] !== handleSortSelect || $[114] !== sortBy || $[115] !== sortOrder) {
    t56 = SORT_OPTIONS.map(option_0 => <MenuItem key={`${option_0.value}-asc`} selected={sortBy === option_0.value && sortOrder === "asc"} onClick={() => handleSortSelect(option_0, "asc")}>{option_0.ascLabel}</MenuItem>);
    t57 = SORT_OPTIONS.map(option_1 => <MenuItem key={`${option_1.value}-desc`} selected={sortBy === option_1.value && sortOrder === "desc"} onClick={() => handleSortSelect(option_1, "desc")}>{option_1.descLabel}</MenuItem>);
    $[112] = SORT_OPTIONS;
    $[113] = handleSortSelect;
    $[114] = sortBy;
    $[115] = sortOrder;
    $[116] = t56;
    $[117] = t57;
  } else {
    t56 = $[116];
    t57 = $[117];
  }
  let t58;
  if ($[118] !== sortMenuAnchor || $[119] !== t54 || $[120] !== t56 || $[121] !== t57) {
    t58 = <Menu anchorEl={sortMenuAnchor} open={t54} onClose={handleSortMenuClose} onClick={handlePropagation} slotProps={t55}>{t56}{t57}</Menu>;
    $[118] = sortMenuAnchor;
    $[119] = t54;
    $[120] = t56;
    $[121] = t57;
    $[122] = t58;
  } else {
    t58 = $[122];
  }
  let t59;
  if ($[123] !== filterMenuAnchor || $[124] !== filterPopoverOpen) {
    t59 = <ProjectBrowserFilters anchorEl={filterMenuAnchor} open={filterPopoverOpen} onClose={handleFilterClose} />;
    $[123] = filterMenuAnchor;
    $[124] = filterPopoverOpen;
    $[125] = t59;
  } else {
    t59 = $[125];
  }
  let t60;
  if ($[126] !== t53 || $[127] !== t58 || $[128] !== t59) {
    t60 = <Box sx={t26}>{t53}{t58}{t59}</Box>;
    $[126] = t53;
    $[127] = t58;
    $[128] = t59;
    $[129] = t60;
  } else {
    t60 = $[129];
  }
  return t60;
};
function _temp(ev) {
  ev.stopPropagation();
}